import { Button, EditIcon } from '@mercai/clever'
import { useTranslation } from 'react-i18next'

import { CardDocuments } from '@/components/card-documents'

import { getLogisticDocuments } from './card-order-logistic-documents.constants'

import styles from './card-order-logistic-documents.module.css'

import type { CardOrderLogisticDocumentsProps } from './card-order-logistic-documents.type'
import { SaleOrderStatusEnum } from '@/types'

export const CardOrderLogisticDocuments = ({
  shipment,
  isLoading,
  onEdit,
  saleOrderStatus,
}: CardOrderLogisticDocumentsProps) => {
  const { t } = useTranslation('componentCardsOrderCenterShow')

  const noEditableStatuses = [
    SaleOrderStatusEnum.completed,
    SaleOrderStatusEnum.cancelled,
  ]

  const isEditable = !noEditableStatuses.includes(
    saleOrderStatus as SaleOrderStatusEnum,
  )

  return (
    <CardDocuments
      data={getLogisticDocuments(t, shipment)}
      isLoading={!!isLoading}
      actions={
        isEditable && onEdit ? (
          <Button
            size="small"
            variant="ghost"
            className={styles.edit}
            onClick={onEdit}
          >
            {t('editLabel')}
            <EditIcon />
          </Button>
        ) : (
          <></>
        )
      }
    />
  )
}
